import Typography from "../Typography/Typography"
import styles from "./style.module.css"
import AnimatedButton from "../AnimatedButton"
import { useNavigate } from "react-router"

export const FailedStoreMessage = () => {

    const navigate = useNavigate()

    return (
        <>

            <div className={styles.container}>

                <div className={styles.congratsContainer}>

                    <div>
                        <Typography
                            variant="heading2"
                            className={styles.congrats}
                        >
                            Oops!, Store Can’t be Created
                        </Typography>
                    </div>

                    <div>
                        <Typography
                            variant="bodyLarge"
                            className={styles.congratsBody}
                        >
                            We couldn’t complete your creation this time. Don’t worry, it’s not your fault.
                        </Typography>
                    </div>
                    <div className={styles.buttonContainer}>

                        <div className={styles.buttonGroup}>
                            <AnimatedButton
                                variant="primary"
                                type="button"
                                onClick={() => {
                                    // window.location.href = '/seller-dashboard';
                                    navigate('/create-store')

                                }}
                                className={styles.primaryButton}
                            >
                                <Typography
                                    variant="buttonText"
                                    fontFamily="satoshi"
                                    weight="regular"
                                    size="base"
                                    className={styles.primaryButtonText}>
                                    Try Again
                                </Typography>
                            </AnimatedButton>
                        </div>

                    </div>

                    {/* <div> */}
                        <Typography
                            variant="heading6"
                            className={styles.congratsBody}
                        >
                            Save Progress for later
                        </Typography>
                    {/* </div> */}
                    {/* <div> */}
                        <Typography
                            variant="heading6"
                            weight="bold"
                            className={styles.congratsBody}
                        >
                            Contact Support
                        </Typography>
                    {/* </div> */}

                </div>

            </div>

        </>
    )
}